class FreeShippingMeter extends HTMLElement {
    constructor() {
        super();
    }

    static freeShippingText = window.free_shipping_text.free_shipping_message;
    static freeShippingText1 = window.free_shipping_text.free_shipping_message_1;
    static freeShippingText2 = window.free_shipping_text.free_shipping_message_2;
    static freeShippingText3 = window.free_shipping_text.free_shipping_message_3;
    static freeShippingText4 = window.free_shipping_text.free_shipping_message_4;
    static classLabel1 = 'progress-30';
    static classLabel2 = 'progress-60';
    static classLabel3 = 'progress-100';
    static checkpoints = [];

    connectedCallback() {
        this.progressBar = this.querySelector('[data-shipping-progress]');
        this.messageElement = this.querySelector('[data-shipping-message]');
        this.progressMeter = this.querySelector('[data-free-shipping-progress-meter]');
        this.textEnabled = this.progressBar?.dataset.textEnabled === 'true';

        // Recupera os checkpoints do window e ordena
        FreeShippingMeter.checkpoints = [
            { threshold: parseInt(window.free_gift_price), label: 'Brinde', class: 'progress-gift' },
            { threshold: parseInt(window.free_shipping_price), label: 'Frete Grátis', class: 'progress-free' }
        ].sort((a, b) => a.threshold - b.threshold);

        // Criar elementos visuais para checkpoints
        this.checkpointElements = {};
        FreeShippingMeter.checkpoints.forEach(checkpoint => {
            this.checkpointElements[checkpoint.label] = this.querySelector(`[data-checkpoint="${checkpoint.threshold}"]`);
        });

        this.addEventListener('change', this.onCartChange.bind(this));
        this.initialize();
    }

    initialize() {
        Shopify.getCart((cart) => {
            this.cart = cart;
            this.calculateProgress(cart);
        });
    }

    onCartChange() {
        this.initialize();
    }

    calculateProgress(cart) {
        const cartTotalPrice = parseInt(cart.total_price) / 100;
        const maxThreshold = FreeShippingMeter.checkpoints[FreeShippingMeter.checkpoints.length - 1].threshold;
        let freeShipBar = Math.abs((cartTotalPrice * 100) / maxThreshold);
        if (freeShipBar >= 100) freeShipBar = 100;

        const text = this.getText(cartTotalPrice);
        const classLabel = this.getClassLabel(cartTotalPrice);

        this.setProgressWidthAndText(freeShipBar, text, classLabel);
        this.updateCheckpoints(cartTotalPrice);
    }

    getText(cartTotalPrice) {
        let text = '';
        for (const checkpoint of FreeShippingMeter.checkpoints) {
            if (cartTotalPrice >= checkpoint.threshold) {
                text = `<span>Você atingiu: ${checkpoint.label}!</span>`;
            } else {
                const remainingPrice = checkpoint.threshold - cartTotalPrice;
                text = `<span>Faltam ${Shopify.formatMoney(remainingPrice * 100, window.money_format)} para ${checkpoint.label}!</span>`;
                break;
            }
        }
        return text;
    }

    getClassLabel(cartTotalPrice) {
        for (const checkpoint of FreeShippingMeter.checkpoints) {
            if (cartTotalPrice < checkpoint.threshold) {
                return checkpoint.class;
            }
        }
        return FreeShippingMeter.checkpoints[FreeShippingMeter.checkpoints.length - 1].class;
    }

    resetProgressClass(classLabel) {
        this.progressBar.className = 'progress';
        this.progressBar.classList.add(classLabel);
    }

    setProgressWidthAndText(freeShipBar, text, classLabel) {
        setTimeout(() => {
            this.resetProgressClass(classLabel);
            this.progressMeter.style.width = `${freeShipBar}%`;
            if (this.textEnabled) {
                this.progressMeter.querySelector('.text').innerHTML = `${freeShipBar.toFixed(2)}%`;
            }
            this.messageElement.innerHTML = text;
        }, 400);
    }

    updateCheckpoints(cartTotalPrice) {
        FreeShippingMeter.checkpoints.forEach(checkpoint => {
            if (this.checkpointElements[checkpoint.label]) {
                this.checkpointElements[checkpoint.label].classList.toggle('active', cartTotalPrice >= checkpoint.threshold);
            }
        });
    }
}

window.addEventListener('load', () => {
    customElements.define('free-shipping-component', FreeShippingMeter);
});
